import React from "react";
import { useTranslation } from "react-i18next";

const Blog2 = ({ content }) => {
  const c = content;

  return (
    <div className="bg-white min-h-screen flex flex-col items-center py-4 px-4">
      <div className="w-full font-inter">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-primary text-2xl md:text-4xl font-inter font-bold text-center mb-5">
            {c.title}
          </h1>
          <div className="text-sm md:text-base text-gray-400 text-center mb-4">
            {c.date} | {c.author}
          </div>
        </div>
        {/* Main Image */}
        <div className="w-full max-w-2xl mx-auto aspect-video bg-white border border-gray-400 rounded-2xl flex items-center justify-center overflow-hidden mb-6">
          <img src={c.image1} alt="Blog main" className="object-cover w-full h-full" />
        </div>
        {/* Highlighted Intro 1 */}
        <div className="w-full bg-primary/20 py-10 mb-6">
          <div className="max-w-2xl mx-auto px-4 text-sm md:text-xl rounded-md">
            <p className="mb-5"><strong>{c.intro1}</strong></p>
            <p className="mb-5">{c.intro2}</p>
            <p>{c.intro3}</p>
          </div>
        </div>
        {/* Section 1 */}
        <div className="max-w-2xl mx-auto px-4 my-6">
          <h2 className="text-primary text-2xl md:text-4xl font-bold mb-5">{c.section1_title}</h2>
          <p>{c.section1_body}</p>
          {c.section1_body2 && <p className="mt-2">{c.section1_body2}</p>}
          {c.section1_list && (
            <ul className="list-disc pl-6 mt-2">
              {c.section1_list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
          {c.section1_body3 && <p className="font-bold mt-2">{c.section1_body3}</p>}
        </div>
        {/* Second Image */}
        <div className="w-full max-w-2xl mx-auto aspect-video bg-white border border-gray-400 rounded-2xl flex items-center justify-center overflow-hidden mb-6">
          <img src={c.image2} alt="Blog secondary" className="object-cover w-full h-full" />
        </div>
        {/* Section 2 */}
        <div className="max-w-2xl mx-auto px-4 my-6">
          <h2 className="text-primary text-2xl md:text-4xl font-bold mb-5">{c.section2_title}</h2>
          {c.section2_list_bad && (
            <ul className="list-disc pl-6 mt-2">
              {c.section2_list_bad.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
          <p className="mt-4 font-bold">{c.section2_body}</p>
          {c.section2_list_good && (
            <ul className="list-disc pl-6 mt-2">
              {c.section2_list_good.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </div>
        {/* Section 3 */}
        <div className="max-w-2xl mx-auto px-4 my-6">
          <h2 className="text-primary text-2xl md:text-4xl font-bold mb-5">{c.section3_title}</h2>
          <p>{c.section3_body}</p>
          {c.section3_body2 && <p className="mt-2 font-bold">{c.section3_body2}</p>}
          {c.section3_list && (
            <ul className="list-disc pl-6 mt-2">
              {c.section3_list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </div>
        {/* Tips Section */}
        <div className="max-w-2xl mx-auto px-4 my-6">
          <h2 className="text-primary text-2xl md:text-4xl font-bold mb-5">{c.tips_title}</h2>
          {c.tips && c.tips.map((tip, i) => (
            <div key={i}>
              <h5 className="font-bold mt-5">{tip.title}</h5>
              <p>{tip.description}</p>
            </div>
          ))}
        </div>
        {/* Conclusion */}
        <div className="max-w-2xl mx-auto px-4 my-6">
          <h2 className="text-primary text-2xl md:text-4xl font-bold mb-5">{c.conclusion_title}</h2>
          <p>{c.conclusion_body}</p>
          {c.conclusion_body2 && <p className="font-bold mt-2">{c.conclusion_body2}</p>}
          <div className="font-bold text-center mt-16"><a
              href="https://www.netme.eu"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-6 py-2 rounded-full font-bold shadow hover:bg-primary-dark transition"
            >
              {c.download}
            </a></div>
        </div>
      </div>
    </div>
  );
};

export default Blog2; 